/* JF25: porządkuje długie nazwy produktów w siatkach i na karcie produktu.
   "PALERMO 8:06 Bergamot & Sandalwood - Świeca sojowa premium - Kolekcja Travels"
   -> nazwa "Palermo 8:06", nuty "Bergamot & Sandalwood", typ "Świeca sojowa premium · Kolekcja Travels". */
(function () {
  var STOP = /^(Naturalna|Naturalny|Naturalne|Świeca|Swieca|Świece|Dyfuzor|Dyfuzory|Home|Room|Wosk|Woski|Perfumy|Premium|Kolekcja|Spray|Funkcjonalny|Funkcjonalna)$/i;
  var SMALL = /^(de|da|do|di|la|le|du|i|of|the|and|&)$/i;

  function nice(s) {
    if (/[a-ząćęłńóśźż]/.test(s)) return s; // ma już małe litery: zostaw pisownię sklepu
    return s.toLowerCase().split(/\s+/).map(function (w, i) {
      if (i > 0 && SMALL.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function parse(title) {
    var t = title.replace(/\s+/g, ' ').trim().replace(/\s[–—]\s/g, ' - ');
    var segs = t.split(' - ');
    var words = segs.shift().split(' ');
    var idx = -1;
    for (var i = 0; i < words.length; i++) { if (words[i].indexOf(':') > -1) { idx = i; break; } }
    var name, notes = '', typeParts = [];
    if (idx > -1) {
      name = words.slice(0, idx + 1).join(' ');
      var rest = words.slice(idx + 1), cut = rest.length;
      for (var j = 0; j < rest.length; j++) { if (STOP.test(rest[j])) { cut = j; break; } }
      notes = rest.slice(0, cut).join(' ');
      if (cut < rest.length) typeParts.push(rest.slice(cut).join(' '));
    } else {
      name = words.join(' ');
    }
    typeParts = typeParts.concat(segs);
    return { name: nice(name), notes: notes, type: typeParts.join(' · ') };
  }

  function kind(t) {
    var K = [[/dyfuzor/i, 'Dyfuzor'], [/home perfume|room|perfumy do wn|do tkanin/i, 'Perfumy do wnętrz'], [/wosk/i, 'Wosk zapachowy'], [/świec|swiec|candle/i, 'Świeca'], [/blend|olejk|essential oil/i, 'Olejek eteryczny'], [/zestaw|set\b/i, 'Zestaw'], [/perfum|edp|eau de parfum/i, 'Perfumy']];
    for (var i = 0; i < K.length; i++) { if (K[i][0].test(t)) return K[i][1]; }
    return '';
  }

  function el(tag, cls, text) { var e = document.createElement(tag); e.className = cls; e.textContent = text; return e; }

  function apply(node, withType) {
    if (!node || node.getAttribute('data-jf')) return;
    var p = parse(node.textContent);
    if (!p.name) return;
    node.setAttribute('data-jf', '1');
    node.setAttribute('title', node.textContent.replace(/\s+/g, ' ').trim());
    var k = withType ? '' : kind(node.textContent);
    node.textContent = '';
    node.appendChild(el('span', 'jf-name', p.name));
    if (k) node.appendChild(el('span', 'jf-kind', k));
    if (p.notes) node.appendChild(el('span', 'jf-notes', p.notes));
    if (withType && p.type) node.appendChild(el('span', 'jf-type', p.type));
  }

  function run(root) {
    (root || document).querySelectorAll('.product-block__title:not([data-jf])').forEach(function (n) { apply(n, false); });
    (root || document).querySelectorAll('h1.product-title:not([data-jf])').forEach(function (n) { apply(n, true); });
    (root || document).querySelectorAll('.jf-product:not([data-jf])').forEach(function (a) {
      a.setAttribute('data-jf', '1');
      var img = a.querySelector('img'), nm = a.querySelector('.jf-product__name');
      var k = img ? kind(img.getAttribute('alt') || '') : '';
      if (k && nm) nm.insertAdjacentElement('afterend', el('p', 'jf-kind jf-product__kind', k));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) { if (m[i].addedNodes.length) { run(); break; } }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
